class MegaMenuLocations {
  constructor() {
    this.menus = document.querySelectorAll("[data-mega-menu-locations]");
    this.init();
  }

  init() {
    this.menus.forEach((menu) => {
      const triggers = menu.querySelectorAll("[data-location-trigger]");
      const contentContainer = menu.querySelector("[data-location-content]");
      const ctaContainer = menu.querySelector(
        "[data-mega-menu-cta-container]"
      );
      const ctaButton = ctaContainer?.querySelector("a, button");

      triggers.forEach((trigger) => {
        trigger.addEventListener("mouseenter", () => {
          this.handleHover(
            trigger,
            contentContainer,
            ctaButton,
            triggers,
            menu
          );
        });
      });

      // Load first location by default
      if (triggers.length > 0) {
        this.handleHover(
          triggers[0],
          contentContainer,
          ctaButton,
          triggers,
          menu
        );
      }
    });
  }

  handleHover(trigger, container, ctaButton, allTriggers, menu) {
    const handle = trigger.dataset.countryHandle;

    // Update active state
    allTriggers.forEach((t) => t.classList.remove("is-active"));
    trigger.classList.add("is-active");

    // Get location data from embedded JSON
    const dataScript = menu.querySelector(`[data-location-data="${handle}"]`);
    if (!dataScript) return;

    try {
      const data = JSON.parse(dataScript.textContent);

      // Update CTA button
      if (ctaButton) {
        ctaButton.href = data.url;
      }

      // Render retailer cards
      this.renderRetailerCards(container, data);
    } catch (error) {
      console.error("MegaMenuLocations: Error parsing JSON:", error);
    }
  }

  renderRetailerCards(container, data) {
  const retailers = data.retailers;
  const retailerCount = data.retailerCount || 0;
  const showCta = retailerCount < 6;


  const ctaCard = `
    <a href="/pages/contact-us" class="mega-menu__retailer-card mega-menu__retailer-card--cta">
      <div class="mega-menu__retailer-card-content">
        <span class="mega-menu__retailer-card-icon">+</span>
      </div>
      <span class="mega-menu__retailer-card-title">Want to work with us?</span>
    </a>
  `;

  if (!retailers || retailers.length === 0) {
    container.innerHTML = `
      <p class="mega-menu__label h6">Find Grounded at</p>
      <div class="mega-menu__retailers">
        <div class="mega-menu__retailer-grid">
          ${ctaCard}
        </div>
      </div>
    `;
    return;
  }

  const retailerSlots = retailers
    .map((retailer) => {
      const hasBrandColor = retailer.brandColor && retailer.brandColor !== "";
      const isBordered = !hasBrandColor;
      const cardClass = isBordered
        ? "mega-menu__retailer-card mega-menu__retailer-card--bordered"
        : "mega-menu__retailer-card";

      return `
        <a href="${retailer.url}" class="${cardClass}">
          ${
            hasBrandColor
              ? `<div class="mega-menu__retailer-card-bg" style="background-color: ${retailer.brandColor}"></div>`
              : ""
          }
          <div class="mega-menu__retailer-card-content">
            ${
              retailer.logo
                ? `<img src="${retailer.logo}" alt="${retailer.title}" class="mega-menu__retailer-card-logo" />`
                : ""
            }
          </div>
          <span class="mega-menu__retailer-card-title" style="${!hasBrandColor ? 'color: black;' : ''}">${retailer.title}</span>
        </a>
      `;
    })
    .join("");

  container.innerHTML = `
    <p class="mega-menu__label h6">Find Grounded at</p>
    <div class="mega-menu__retailers">
      <div class="mega-menu__retailer-grid">
        ${retailerSlots}
        ${showCta ? ctaCard : ''}
      </div>
    </div>
  `;
  }
}

// Initialize
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new MegaMenuLocations());
} else {
  new MegaMenuLocations();
}